import { render } from "./Push.vue?vue&type=template&id=504650af&ts=true"
import script from "./Push.vue?vue&type=script&lang=ts"
export * from "./Push.vue?vue&type=script&lang=ts"

import "./Push.vue?vue&type=style&index=0&id=504650af&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__